import moment from 'moment';

import request from 'utils/request';

const managedIntegrations = {
  get: async (managedIntegrationUuid) =>
    await request.get(`/managed_integrations/${managedIntegrationUuid}`),
  list: async (queryParams) => {
    return await request.get('/managed_integrations', {
      ...queryParams,
      related_object_type_in: queryParams?.relatedObjectTypeIn?.join(','),
    });
  },
  delete: async (managedIntegrationUuid) => {
    return await request.delete(
      `/managed_integrations/${managedIntegrationUuid}`,
    );
  },
};

const managedIntegrationActionsDefinitions = {
  get: async (managedIntegrationUuid) =>
    await request.get(
      `/managed_integrations/public/${managedIntegrationUuid}/integration_action_definitions`,
    ),
};

const transformManagedIntegrationActionFiltersParamsToApi = ({
  orderNumber,
  quoteNumber,
  relatedObjectTypeIn,
  sort,
  statusIn,
  typeIn,
  updatedRange,
  page,
}) => ({
  order_number: orderNumber || undefined,
  quote_number: quoteNumber || undefined,
  related_object_type_in: relatedObjectTypeIn || undefined,
  sort:
    sort && Array.isArray(sort) && sort.length > 0 ? sort.join(',') : undefined,
  status_in:
    statusIn && Array.isArray(statusIn) && statusIn.length > 0
      ? statusIn.join(',')
      : undefined,
  type_in:
    typeIn && Array.isArray(typeIn) && typeIn.length > 0
      ? typeIn.join(',')
      : undefined,
  updated_range:
    updatedRange && Array.isArray(updatedRange) && updatedRange.length === 2
      ? `${moment(updatedRange[0]).format()},${moment(
          updatedRange[1],
        ).format()}`
      : undefined,
  page: page || undefined,
});

const managedIntegrationActions = {
  get: async (managedIntegrationUuid, filters, page) => {
    const queryParams = transformManagedIntegrationActionFiltersParamsToApi({
      ...(filters || {}),
      page,
    });

    return await request.get(
      `/managed_integrations/${managedIntegrationUuid}/integration_actions`,
      queryParams,
    );
  },

  create: async (managedIntegrationUuid, data) => {
    await request.post(
      `/managed_integrations/${managedIntegrationUuid}/integration_actions`,
      data,
    );
  },
};

const managedIntegrationTemplate = {
  get: async (integrationTemplateId) => {
    return await request.get(
      `/managed_integrations/integration_templates/${integrationTemplateId}`,
    );
  },
  list: async (queryParams) => {
    return await request.get(
      `/managed_integrations/integration_templates`,
      queryParams,
    );
  },
  create: async (data) => {
    return await request.post(`/managed_integrations/`, data);
  },
  createLogo: async (data) => {
    return await request.post(`/managed_integrations/logo`, data);
  },
  patch: async (data) => {
    return await request.patch(`/managed_integrations/${data.uuid}`, data);
  },
  deleteLogo: async (logoId) => {
    return await request.delete(`/managed_integrations/logo/${logoId}`);
  },
};

const managedIntegrationActionDefinitions = {
  get: async (integrationActionDefinitionId) => {
    return await request.get(
      `/managed_integrations/integration_action_definitions/${integrationActionDefinitionId}`,
    );
  },
  list: async (managedIntegrationUuid) => {
    return await request.get(
      `/managed_integrations/${managedIntegrationUuid}/integration_action_definitions`,
    );
  },
  create: async (managedIntegrationUuid, data) => {
    await request.post(
      `/managed_integrations/${managedIntegrationUuid}/integration_action_definitions`,
      data,
    );
  },
  edit: async (actionDefinitionUuid, data) => {
    await request.patch(
      `/managed_integrations/integration_action_definitions/${actionDefinitionUuid}`,
      data,
    );
  },
  delete: async (integrationActionDefinitionId) => {
    return await request.delete(
      `/managed_integrations/integration_action_definitions/${integrationActionDefinitionId}`,
    );
  },
};

export default {
  managedIntegrations,
  managedIntegrationActions,
  managedIntegrationActionsDefinitions,
  managedIntegrationTemplate,
  managedIntegrationActionDefinitions,
};
